import React from "react";
import logo from "../../Assets/images/logo-rmbg.png"; 
import "./SchoolLogo.css";

const SchoolLogo = () => {
  return (
    <div className="school-logo">
      <img src={logo} alt="UGAAL-LOGO" />

      <div className="school-name">
        <span className="school-name-main">University of Ghana</span>
        <span className="school-name-sub">Alumni Association Liberia</span>
      </div>
    </div>
  );
};

export default SchoolLogo;
